export default "__VITE_ASSET__BfohdZTq__"